import classNames from 'classnames/bind';
import React from 'react';
import { MessageProps } from 'semantic-ui-react';

import { Message } from 'reactComponents/Message/Message';

import styles from './WarningMessage.css';

const css = classNames.bind(styles);

type WarningMessageProps = MessageProps & { lessPadding?: boolean };

export const WarningMessage = ({
    lessPadding,
    className,
    ...props
}: WarningMessageProps) => (
    <Message
        className={css(
            {
                lessPadding,
            },
            className,
        )}
        {...props}
    />
);
